import {ReactNode, useCallback, useState} from 'react';

import {VehicleWarehouseContext} from './VehicleWarehouseContext';

type VehicleWarehouseProviderProps = {
  children: ReactNode;
};

export const VehicleWarehouseProvider = (props: VehicleWarehouseProviderProps) => {
  const [refreshTick, setRefreshTick] = useState(0);

  const refreshDataGrid = useCallback(() => {
    setRefreshTick((t) => t + 1);
  }, []);

  return (
    <VehicleWarehouseContext.Provider value={{refreshDataGrid, refreshTick}}>
      {props.children}
    </VehicleWarehouseContext.Provider>
  );
};
